import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { isObject, useT } from '@progress-fe/core';
import { Input, InputNumber, Select } from '../../../inputs';
const TableEditableValueFC = ({ value, isDisabled, isInvalid, type = 'number', options = [], unit, onChangeValue }) => {
    const { t } = useT();
    const renderedValue = isObject(value) ? value?.value : value;
    switch (type) {
        case 'string':
            return (_jsx(Input, { size: "xs", variant: "outline", sx: { width: '100%' }, isOnChangeOnlyOnBlur: true, disabled: isDisabled, isInvalid: isInvalid, value: renderedValue || '', rightElement: unit || undefined, onChange: (newValue) => onChangeValue(newValue || '') }));
        case 'select':
            return (_jsx(Select, { wide: true, inPortal: true, name: "model", options: options, isDisabled: isDisabled, placeholder: t('common.notSelected'), value: options.find((opt) => opt.value === renderedValue), isInvalid: isInvalid, onChange: (selected) => {
                    onChangeValue(selected.value);
                } }));
        default:
            return (_jsx(InputNumber, { isFloat: type === 'float', min: 0, size: "xs", variant: "outline", sx: { width: '100%' }, isOnChangeOnlyOnBlur: true, disabled: isDisabled, value: renderedValue || '', rightElement: unit || undefined, isInvalid: isInvalid, onChange: (newValue) => onChangeValue(newValue || '') }));
    }
};
export const TableEditableValue = memo(TableEditableValueFC);
//# sourceMappingURL=TableEditableValue.js.map